import React from "react";
import moment from "moment";
import WeatherComponent from "../WeatherComponent/WeatherComponent";

const Weather = ({ prediction, fullDates }) => {
  return (
    <div className="weather-overview">
      <div className="condition-today prediction panel">
        {prediction && prediction[0] && (
          <>
            <h4>Today</h4>
            <div className="grid cols-2">
              <WeatherComponent icon={prediction[0].element} />
              <WeatherComponent icon={prediction[0].condition} />
            </div>
          </>
        )}
      </div>
      <div className="prediction-container">
        {prediction &&
          prediction.slice(1).map((day, i) => (
            <div key={i} className="prediction">
              <h4>{moment(day.date).format(fullDates ? "YYYY-MM-DD" : "ddd")}</h4>
              {day.condition ? (
                <div className="grid cols-2">
                  <WeatherComponent icon={day.element} />
                  <WeatherComponent icon={day.condition} />
                </div>
              ) : (
                <WeatherComponent icon={day.element} />
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Weather;
